import { render, staticRenderFns } from "./SelectBaseCurrency.vue?vue&type=template&id=31346c3a&scoped=true"
import script from "./SelectBaseCurrency.vue?vue&type=script&lang=js"
export * from "./SelectBaseCurrency.vue?vue&type=script&lang=js"
import style0 from "./SelectBaseCurrency.vue?vue&type=style&index=0&id=31346c3a&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "31346c3a",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VAvatar } from 'vuetify/lib/components/VAvatar';
import { VCard } from 'vuetify/lib/components/VCard';
import { VCardTitle } from 'vuetify/lib/components/VCard';
import { VCol } from 'vuetify/lib/components/VGrid';
import { VContainer } from 'vuetify/lib/components/VGrid';
import { VItem } from 'vuetify/lib/components/VItemGroup';
import { VItemGroup } from 'vuetify/lib/components/VItemGroup';
import { VListItemContent } from 'vuetify/lib/components/VList';
import { VListItemSubtitle } from 'vuetify/lib/components/VList';
import { VListItemTitle } from 'vuetify/lib/components/VList';
import { VRow } from 'vuetify/lib/components/VGrid';
import { VSelect } from 'vuetify/lib/components/VSelect';
installComponents(component, {VAvatar,VCard,VCardTitle,VCol,VContainer,VItem,VItemGroup,VListItemContent,VListItemSubtitle,VListItemTitle,VRow,VSelect})
